import React from 'react'
import Icon from '../../components/Icon'
import moment from 'moment'
import copyStrToClipboard from '../../utils/copyStrToClipboard'
import { toast } from 'react-toastify'

const styleForIcon = {
  fontSize: 18,
  verticalAlign: 1,
  marginRight: 5,
}

const Detail = ({ item, collections, openEdit }) => {
  return (
    <div className="col-8">
      DETAILS
      <div className="my-2 border collectionItem knackly-plain p-2">
        <div className="col-12 d-flex justify-content-between mt-3">
          <div>
            <h3>{item.label ? item.label : item._id}</h3>
          </div>
          <div onClick={() => openEdit()}>
            <Icon type="icon-pencil-alt" className={'animeteScale'}
                  style={{ fontSize: 22 }}/>
          </div>
        </div>
        <div className="col-7">
          <div className="row pb-3">
            <div className="col-3 my-1">Access Key ID:</div>
            <div className="col-9 my-1">
              <div className="row">
                <div className="col text-truncate">{item._id}</div>
                <div className="col" onClick={() => {
                  copyStrToClipboard(item._id)
                  toast.success(
                    'Access Key ID reference copied to the clipboard', {
                      position: toast.POSITION.TOP_CENTER,
                      pauseOnFocusLoss: false,
                      autoClose: 1500,
                    })
                }}>
                  <Icon type="icon-copy"
                        className={'animeteScale'}
                        style={{ fontSize: 16 }}/>
                </div>
              </div>
            </div>
            <div className="col-3 my-1">Access Secret:</div>
            <div className="col-9 my-1">
              <div className="row">
                <div className="col text-truncate">{item.key}</div>
                <div className="col" onClick={() => {
                  copyStrToClipboard(item.key)
                  toast.success(
                    'Access Secret reference copied to the clipboard', {
                      position: toast.POSITION.TOP_CENTER,
                      pauseOnFocusLoss: false,
                      autoClose: 1500,
                    })
                }}>
                  <Icon type="icon-copy"
                        className={'animeteScale'}
                        style={{ fontSize: 16 }}/>
                </div>
              </div>
            </div>
            <div className="col-3 my-1">Label:</div>
            <div className="col-9 my-1">{item.label}</div>
            <div className="col-3 my-1">Admin Access:</div>
            <div className="col-9 my-1">{item.hasAdminAccess
              ? 'Yes'
              : 'No'}</div>
            <div className="col-3 my-1">Date created:</div>
            <div className="col-9 my-1">{moment(item.date).format('lll')}</div>
            <div className="col-3 my-1">Permissions:</div>
            <div className={'col-7 my-1'}>
              <div className={'w-100 p-2 knackly-back overflow-auto'} style={{maxHeight: '58vh'}}>
                <div className={'d-flex flex-row'}>
                  <div className={'pb-2 pl-2 knacklyBlock d-flex'}>Catalog</div>
                  <div className={'pb-2 knacklyBlock d-flex'}
                      /* style={{ width: 75 }}*/>Read/Write Access
                  </div>
                </div>
                {collections.map(collection => (
                  <div key={'permission-' + collection.name}
                       className={'d-flex flex-row'}>
                    <div className={'knackly-plain py-2 pl-2 blockPermissions'}>
                      <Icon type={'icon-cabinet1'}
                            style={styleForIcon}/>{collection.name}
                    </div>
                    <div className={'knackly-plain py-2 blockPermissions'}
                        /* style={{ width: 75 }}*/>
                      <div className="form-check text-center p-0 m-0">
                        <input
                          className="form-check-input position-static p-0 m-0"
                          type="checkbox"
                          checked={item.permissions.includes(collection._id)}/>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Detail
